module.exports = __webpack_public_path__ + "img/source04_7.f12be6e0.png";